// extracted by mini-css-extract-plugin
module.exports = {"stubInput":"DatePickerInputStub_stubInput__2d72Q"};